/** @jsx jsx */
import { jsx, Box, Container, Flex } from 'theme-ui';
/* eslint-disable react/no-danger */
import React from 'react';
import BackgroundImage from 'gatsby-background-image';

// Node Types
import { SectionComponent } from '@codersclan/gatsby-theme-airfleet/src/@types';

// Types
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';
import { CTA } from '../../@types/cta';

// Components
import Text, { TEXT_TYPES } from '../../components/text';
import Card from '../../components/card';

// Styles
import { baseStyle } from './style';

interface BoxType extends CTA {
  backgroundImage: ImageType;
  textarea: string;
  title: string;
}

interface Title2BoxesBgProps extends Section {
  backgroundImage: {
    backgroundImage: ImageType;
  };
  boxes: {
    boxes: BoxType[];
  };
  title: {
    title: string;
  };
};

const Title2BoxesBg: SectionComponent<Title2BoxesBgProps> = React.memo(
  ({ backgroundImage, boxes, title }) => (
    <Box>
      <BackgroundImage
        fluid={
          backgroundImage.backgroundImage.localFile?.childImageSharp?.fluid
        }
        sx={baseStyle.mainBackgroundImage}
      >
        <Container sx={baseStyle.mainContainer}>
          <Text type={TEXT_TYPES.H1_BOLD} sx={baseStyle.title}>
            {title.title}
          </Text>
          <Flex sx={baseStyle.flexContainer}>
            {boxes.boxes.map((box: BoxType, idx: number) => (
              <Card
                // eslint-disable-next-line react/no-array-index-key
                key={idx}
                title={box.title}
                content={box.textarea}
                image={box.backgroundImage}
                cta={box}
                sx={baseStyle.box}
              />
            ))}
          </Flex>
        </Container>
      </BackgroundImage>
    </Box>
  ),
);

export default Title2BoxesBg;
